module.exports = __webpack_public_path__ + "media/3x/N-f9f84cc4.png";